export default "__VITE_ASSET__h8dURVA5__"